import { Injectable } from '@angular/core';
import { BaseService } from '@base/base.service';
import { Observable } from 'rxjs';
import { Product } from './models/product.model';

@Injectable()
export class ProductsService extends BaseService<Product> {
  serviceUrl = '/api/products';

  decrypt(item: any): Observable<any> {
    item = this.cleanMeta(item);
    return this.http.post<any>(this.serviceUrl, item);
  }

  validateProduct(productId: any): Observable<any> {
    return this.http.post<any>(`${this.serviceUrl}/validate`, { productId });
  }

  getShopifyProducts(): Observable<any> {
    return this.http.get<any>(`${this.serviceUrl}/shopify/products`);
  }

  getSubscriptionProducts(): Observable<any> {
    return this.http.get<any>(`${this.serviceUrl}/subscription-products`);
  }

  getSubscriptionPlans(): Observable<any> {
    return this.http.get<any>(`${this.serviceUrl}/subscription-plans`);
  }

  getProductSun(): Observable<any> {
    return this.http.get<any>(`${this.serviceUrl}/product-sun`);
  }

  checkDuplicates(): Observable<any> {
    return this.http.get<any>(`${this.serviceUrl}/duplicates`);
  }
}
